export enum FilterType {
  CATERGORY = 'category',
  DATE = 'date',
  LOCATION = 'location',
  INTERSETS = 'interests',
  QUERY = 'query'
}
